import { useTranslation } from "react-i18next";
import { cx } from "../cx";
import { type StateKind, type StateOf, type StateTone, toneOf } from "./stateTone";

const TONE: Record<StateTone, string> = {
  muted: "text-ink-3 line-through",
  neutral: "text-ink-3",
  working: "text-accent",
  accent: "text-accent",
  ok: "text-ok",
  warn: "text-warn",
  danger: "text-danger",
};

/**
 * A Book, Chapter, or Job state as the mockups draw it: a mono word in its
 * tone colour ("freigegeben" green, "Durchsicht" blue). `badge` adds the
 * bordered box for places without a table around it.
 */
export function StateChip<K extends StateKind>({
  kind,
  state,
  badge = false,
  className = "",
}: {
  kind: K;
  state: StateOf<K>;
  badge?: boolean;
  className?: string;
}) {
  const { t } = useTranslation("states");
  const tone = toneOf(kind, state);
  return (
    <span
      data-component="StateChip"
      data-kind={kind}
      data-state={state}
      data-tone={tone}
      className={cx(
        "inline-flex items-center whitespace-nowrap font-mono text-data",
        TONE[tone],
        badge && "h-[22px] rounded-sm border border-current px-2 text-label",
        className,
      )}
    >
      {t(`${kind}.${state}`)}
    </span>
  );
}
